<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div class="container-fluid" id="blurry">
    <div class="row signup-page">
      <div class="circle_background_mob" ></div>
      <div class="col-lg-12 touch_bottom">
        <div class="signup-page--right whiteandround">
          <div class="login-form">
            <div class="logo_form"><img :src="getTranslations.project_logo_img" alt=""></div>
            <div class="form_title" v-if="!hasHE && !validationForOneTimeSubscription && !show2stepsOnlyOrNoneInForgot()">
              <h1>{{ getTranslations.visitor_sign_up_2_two_steps_left }}</h1>
            </div>
            <div class="form_title" v-if="!hasHE && !validationForOneTimeSubscription && show2stepsOnlyOrNoneInForgot()">
              <h1>{{ getTranslations.visitor_sign_up_3_almost_done }}</h1>
            </div>
          </div>

          <div class="col-lg-12" v-if="!hasHE && !validationForOneTimeSubscription">
            <div :class="['StandardRegSteps_Container ', show2stepsOnlyOrNoneInForgot() ? 'twoStepRegSteps_Container' : '' ]">
              <div :class="['StandardRegSteps_step ' , show2stepsOnlyOrNoneInForgot() ? 'twoStepRegSteps_step step_done' : 'step_done' ]" >1
              </div>
              <div :class="['StandardRegSteps_step ' , show2stepsOnlyOrNoneInForgot() ? 'twoStepRegSteps_step' : '' ]" >2
              </div>
              <div class="StandardRegSteps_step inactive" v-if="!show2stepsOnlyOrNoneInForgot()">3
              </div>
            </div>
          </div>
          <div class="signup-form">
            <div class="form-help extra_padng">
              <p>{{ getTranslations.visitor_sign_up_2_info_msg_unique_code_send }}</p>
              <img class="form-help__icon"
                   src="static//images/mobile-icon.svg"
                   alt="">
            </div>
            <form action="">
              <div class="form-group form-group--icon"
                   :class="[ (!hasErrors && !message) ? '' : 'has-warning' ]">
                <input type="password"
                       class="password form-group__textfield"
                       :class="[ !hasErrors ? 'has-success' : 'has-warning' ]"
                       :placeholder="getTranslations.visitor_sign_up_2_validation_code"
                       @keyup="check"
                       v-model="user.pin"/>
                <span v-show="getMessage(message) && user.pin"
                      class="form-group__feedback">{{ getMessage(message) }}
                </span>
              </div>
              <div v-if="!checkIntegration" class="form-footer">
                <p>{{ getTranslations.visitor_sign_up_1_single_country_free_for }}</p>
              </div>
              <div class="col-lg-12">
                <p>{{ getTranslations.visitor_sign_up_3_info_msg_agree_to_terms }}<a>
                <a :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_terms_and_conditions')" class="alter_flow_link" target="_blank"
                   v-if="!checkIfTranslationEmptyByOrdinal(multiOperatorInfo.multiOperatorOrdinal, 'visitor_sign_up_3_terms_and_conditions')">
                  {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'visitor_sign_up_3_terms_and_conditions') }}</a>
                </a>
                </p>
              </div>


              <input type="submit" id="submitBtn"
                     :value="getTranslations.visitor_sign_up_2_submit_button_continue"
                     :class="['btn btn--medium btn--main' , ( hasErrors || waitForResponse ? 'deactivated' : '')]"
                     @click.prevent="checkButton">

              <br><br>
              <a class="alter_flow_link" href="https://www.google.com" v-if="!checkIfTranslationEmptyByOrdinal(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_2_exit')">
                {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_2_exit') }}
              </a>
              <br><br>

              <p class="bottom_disclaimer_extra" v-if="!checkIfTranslationEmptyByOrdinal(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_2_disclaimer_extra')">
                {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_2_disclaimer_extra') }}</p>


              <div class="form-footer-text">
                <p> {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'visitor_sign_up_1_single_country_start_free') }}</p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <loading v-if="showLoadingModal"
             @close="showLoadingModal = false">
    </loading>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import RegistrationFlowMixin from '@/common/mixins/flow';
import IntegrationMixin from '@/common/mixins/integration';
import loading from '@/components/home/modals/Loading';

export default {
  name: 'sign-up-2',
  components: { loading },
  mixins: [IntegrationMixin, RegistrationFlowMixin],
  data() {
    return {
      user: {
        pin: '',
        msisdn: '',
      },
      ti: null,
      ts: null,
      message: '',
      hasErrors: false,
      blacklistWords: [],
      waitForResponse: false,
      validationForOneTimeSubscription: null,
    };
  },
  created() {
    const inputMsisdn = sessionStorage.getItem('msisdn') || this.$route.query.userMsisdn || this.$route.query.msisdn;
    if (inputMsisdn) this.setRegistrationInfo(inputMsisdn);
    const operator = this.$route.query.operator;

    if (this.integrationHeader === this.availableIntegrations.KOREK_IRAQ.name) {
      this.ti = this.generateValue();
      this.ts = this.secondsEpoch();
      /* eslint-disable */
      const params = { ti: this.ti, ts: this.ts, te: '#submitBtn', servicename: 'Treasures', merchantname: 'Trendy' };
      const paramString = new URLSearchParams(params);
      const url = `https://korek-he.trendy-technologies.com/dcbprotect.php?action=script&${paramString.toString()}`;
      if (sessionStorage.getItem('isRun') === 'true') {
        $.get(url, function (data) {
          console.log(data);
          let scriptToAdd = document.createElement('script');
          scriptToAdd.type = 'text/javascript';
          scriptToAdd.id = 'korek_response';
          // Create contents of the script
          let inlineScript = document.createTextNode("if(sessionStorage.getItem('isRun') === 'true') {\n");
          scriptToAdd.appendChild(inlineScript);
          inlineScript = document.createTextNode(data.s);
          scriptToAdd.appendChild(inlineScript);
          inlineScript = document.createTextNode("\n}");
          scriptToAdd.appendChild(inlineScript);
          document.head.appendChild(scriptToAdd);
          let tag = document.createElement("script");
          tag.type = 'text/javascript';
          tag.id = 'db_response';
          inlineScript = document.createTextNode("if(sessionStorage.getItem('isRun') === 'true') {\n");
          tag.appendChild(inlineScript);
          inlineScript = document.createTextNode("var event = new Event('DCBProtectRun');\n");
          tag.appendChild(inlineScript);
          inlineScript = document.createTextNode("document.dispatchEvent(event); \n}");
          tag.appendChild(inlineScript);
          inlineScript = document.createTextNode("sessionStorage.setItem('isRun', 'false');");
          tag.appendChild(inlineScript);
          document.head.appendChild(tag);
        });
      }
      if (document.getElementById('korek_response')) {
        document.getElementById('korek_response').remove();
        document.getElementById('db_response').remove();
        sessionStorage.setItem('isRun', 'true');
      }
    }
    /* eslint-enable */
    if (operator) {
      this.storeOperator(operator);
      this.$axios.get(`publicapi/getMultiOperatorConfigProperties?operatorKey=${operator}`).then((response) => {
        this.updateMultiOperatorOrdinal({ value: response.data.data.multiOperatorOrdinal });
        this.setDisplayPrice({ value: response.data.data.displayPrice });
      });
    }
    this.validationForOneTimeSubscription = (!this.getIntegrationByName()) ? false : this.getIntegrationByName().value.oneTimeSubscription;
  },
  methods: {
    ...mapActions('common', [
      'storeOperator',
    ]),
    ...mapMutations('profile', [
      'setRegistrationInfo',
    ]),
    ...mapMutations('common', [
      'updateMultiOperatorOrdinal',
      'setDisplayPrice',
    ]),
    generateValue() {
      // eslint-disable-next-line
      return 1001 + '-' + Math.floor(Math.random() * Date.now()) + '-' + Math.floor(Math.random() * Date.now());
    },
    secondsEpoch() {
      return Math.floor(Date.now() / 1000);
    },
    getMessage(key) {
      if (key === 'SERVER_ERROR') return key;
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, key) || '';
    },
    checkIfTranslationEmptyByOrdinal(ordinal, key) {
      const indexKey = (ordinal ? `${key}.${ordinal}` : key);
      return !this.getTranslations[indexKey];
    },
    sendNewCode() {
      this.$axios.get(`api/requestPin?msisdn=${encodeURIComponent(this.getRegistrationInfo)}&lang=${this.getLocale}`).then((response) => {
        const res = response.data.responseEnum;
        if (res === 'OPERATION_SUCCESS') {
          this.$router.push('register2');
        } else {
          if (res === 'MSISDN_INVALID') {
            this.message = 'visitor_sign_up_invalid_msisdn_msg';
          } else if (res === 'ALREADY_REGISTERED') {
            this.message = 'visitor_sign_up_msisdn_already_registered';
          } else if (res === 'MSISDN_NOT_EXIST') {
            this.message = 'visitor_sign_up_msisdn_not_exists';
          } else if (res === 'MSISDN_BLACKLISTED') {
            this.message = 'visitor_sign_up_msisdn_blacklisted';
          } else if (res === 'BLOCKED_USER') {
            this.message = 'visitor_forgot_password_warning_msd_max_attempts';
          } else if (res === 'SERVER_ERROR') {
            this.message = 'home_profile_profile_edit_server_unvailable';
          } else if ((res === 'THIRD_PARTY_PIN_REQUEST_FAILED') || (res === 'THIRD_PARTY_PIN_VERIFICATION_FAILED') || (res === 'THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED')) {
            this.message = 'visitor_sign_up_warning_third_party_error';
          }
          this.hasErrors = true;
        }
      });
    },
    check: function check() {
      const validPinRegex = /^[0-9]{0,8}$/;
      const validPin = this.user.pin.match(validPinRegex);
      if (!validPin) {
        this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
        this.hasErrors = true;
      } else {
        this.hasErrors = false;
        this.message = '';
      }
    },
    checkIntegration() {
      if (this.integrationHeader === this.availableIntegrations.DU_ETISALAT.name) {
        return true;
      }
      return false;
    },
    checkButton() {
      if (this.integrationHeader === this.availableIntegrations.KOREK_IRAQ.name) {
        if (document.getElementById('korek_response')) {
          document.getElementById('korek_response').remove();
          document.getElementById('db_response').remove();
        }
      }
      if (this.user.pin.length >= 4 && this.user.pin.length <= 8 && !this.hasErrors) {
        this.message = '';
        this.waitForResponse = true;
        const alternateVerifyStep = this.getAlternateVerifyPinAction(this.ti, this.ts);
        if (alternateVerifyStep) {
          alternateVerifyStep.call(this);
        } else {
          this.getNextRegistrationStep()();
        }
      } else {
        this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
        this.hasErrors = true;
      }
    },
  },
  computed: {
    ...mapState('common', [
      'refUrl',
      'clickid',
      'multiOperatorInfo',
      'integrationHeader',
      'availableIntegrations',
      'displayPrice',
    ]),
    ...mapState('profile', [
      'registrationInfoMsisdn',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
      'getLocale',
    ]),
    ...mapGetters('common', [
      'getRefUrl',
      'getClickId',
      'getCampaignId',
      'getPublisherId',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/signup/SignUp2.vue